export default __webpack_public_path__ + "static/media/Plantas.1682cd42.png";